import { render, staticRenderFns } from "./IconBannerWidget.vue?vue&type=template&id=1e28ca59&scoped=true"
import script from "./IconBannerWidget.vue?vue&type=script&lang=ts"
export * from "./IconBannerWidget.vue?vue&type=script&lang=ts"
import style0 from "./IconBannerWidget.vue?vue&type=style&index=0&id=1e28ca59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e28ca59",
  null
  
)

export default component.exports